import { SubmitButton } from "./SubmitButton";

export * from "./SubmitButton";

export default SubmitButton;
